export enum UserPosition {
  Administrator = 'administrator',
  SubAdministrator = 'sub-administrator',
  TeamLead = 'teamlead',
  Member = 'member',
}
